import type { MagicEventFragment } from '@/features/events/fragments/MagicEventFragment.generated';

/**
 * An event with no per-experience overrides at all.
 *
 * `metadata` is non-null on the schema and is selected by MagicEvent, so every
 * literal that builds an event fragment has to supply it: client-only drafts,
 * the quick-create share page's converted entries, and test factories. They all
 * mean the same thing, so they share this rather than each writing out a block
 * of blanks that has to be kept in step with the selection.
 *
 * A function, not a frozen constant: callers spread their own values over the
 * result, and handing out one shared object would let a mutation downstream
 * leak into every other event.
 */
export const emptyEventMetadata = (): MagicEventFragment['metadata'] => ({
  category: null,
  hidden: [],
  inheritedHidden: [],
  kind: null,
  emoji: null,
  notes: null,
  labels: [],
  whoLabels: [],
});
